import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Modal from 'react-modal';
import { createRoot } from 'react-dom/client';

import { Language } from '@/constants';
import { storage } from '@/services';

import ErrorBoundary from '@/components/ErrorBoundary';
import { LanguageProvider } from '@/components/Language';
import { SessionProvider } from '@/components/Context/Session';

import App from './App';

const dom: HTMLElement | null = document.getElementById('app');

const updateUserLocale: (language: Language) => void = (language) => {
  storage.setItem('locale', language);
};

const getUserLocale: () => Language = () => storage.getItem('locale') || Language.English;

Modal.setAppElement(dom);

const root = createRoot(dom);

root.render(
  <LanguageProvider language={getUserLocale()} onUpdate={updateUserLocale}>
    <ErrorBoundary>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </LanguageProvider>,
  dom
);
